import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Layout from "./Layout";
import Signin from "./Auth/signin";
import { isContratoAceito } from "./Auth/actions";
import Welcome from "./Welcome";
import WelcomeCategory from "./Welcome/Category";
import Company from "./Company";
import ViewResult from "./Company/Result/GridView";
import Recovery from "./Recovery";
import Contract from "./Contract";
import { setSessaoToken, Sessao } from "../helpers/Token";

import Loading from "../components/Loading";
import { axiosPisCofins } from "../constants/axiosConfig";

import LoginWrapper from "./LoginWrapper";
import { useKeycloak } from "@react-keycloak/web";

/**
 * Verfica se estamos rodando em modo development
 * Caso esteja em modo development a p�gina de login estar�
 * dispon�vel para evitar ter que rodar o Conta �nica
 * simplesmente para realizar o login
 */
const isDevelopment = () => process.env.NODE_ENV === "development";

/**
 * Verifica se o sessionStorage da aplica��o tem o token Jwt
 */
const isAuthenticated = () => {
  const tokenJwt = sessionStorage.getItem("eRecuperadorJwt");
  return !!tokenJwt;
};

/**
 * Verifica se o usu�rio est� logado (tem o token JWT) para
 * permitir as p�ginas do sistema. Caso contr�rio redireciona
 * para a p�gina de login (em mo desenvolvimento) ou para o
 * Conta �nica (em produ��o)
 **/
const PrivateRoute = ({ component: Component, ...rest }) => {
  const {
    keycloak: { authenticated },
  } = useKeycloak();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (authenticated === false) {
          return <>{(window.location = process.env.REACT_APP_CONTA_URL)}</>;
        } else {
          return <Component {...props} />;
        }
      }}
    />
  );
};

class App extends Component {
  constructor(props) {
    super(props);
  }

  // tryLogin = () => {
  //   if (window.location.pathname === "/") {
  //     axiosPisCofins
  //       .post("usuario/obterDadosUsuario", {})
  //       .then(async (response) => {
  //         const {
  //           Login,
  //           IdLogin,
  //           IsAdmin,
  //           PlanoMaster,
  //           PlanoRecuperadorLimitado,
  //           LogoEmpresa,
  //           PlanoTeste,
  //           CodigoAcessoPlanilha,
  //           OcultarPlanilhaCalculo,
  //           NomeDoUsuario,
  //           ClienteRazaoSocial,
  //           PlanoProfissionalLiberal,
  //           PlanoMeuPrimeiroClienteCompleto
  //         } = response.data.Retorno;

  //         if (response.data?.StatusCode === 200) {
  //           sessionStorage.setItem("Login", window.btoa(Login));
  //           sessionStorage.setItem("IdLogin", window.btoa(IdLogin || 0));
  //           sessionStorage.setItem("nome", NomeDoUsuario);
  //           sessionStorage.setItem("email", Login);
  //           setSessaoToken({
  //             planoMaster: PlanoMaster,
  //             planoTeste: PlanoTeste,
  //             planoRecuperadorLimitado: PlanoRecuperadorLimitado,
  //             codigoAcessoPlanilha: CodigoAcessoPlanilha,
  //             ocultarPlanilhaCalculo: OcultarPlanilhaCalculo,
  //             clienteRazaoSocial: ClienteRazaoSocial,
  //             planoProfissionalLiberal: PlanoProfissionalLiberal,
  //             planoMeuPrimeiroClienteCompleto: PlanoMeuPrimeiroClienteCompleto
  //           });

  //           if (IsAdmin) sessionStorage.setItem("IsAdmin", IsAdmin);
  //           if (LogoEmpresa) sessionStorage.setItem("LogoEmpresa", LogoEmpresa);

  //           if (await isContratoAceito()) {
  //             window.location = "/bemvindo";
  //           } else {
  //             window.location = "/contrato";
  //           }
  //         } else {
  //           let contaUrl = process.env.REACT_APP_CONTA_URL;

  //           if (response.data?.StatusCode === 401 && response.data.Mensagem) {
  //             contaUrl = contaUrl + `/Home/Conta?mensagem=${response.data.Mensagem}`;
  //           }

  //           window.location = contaUrl;
  //         }
  //       })
  //       .catch((error) => {
  //         if (
  //           error &&
  //           error &&
  //           error.response &&
  //           error.response.status === 483
  //         ) {
  //           // Caso n�o esteja logado, redireciona para o Conta ou para o Login
  //           window.location = `${process.env.REACT_APP_CONTA_URL}/Home/Conta?idstatus=4`;
  //         } else {
  //           // Em caso de erro, redireciona para o Conta ou para o Login
  //           window.location = process.env.REACT_APP_CONTA_URL;
  //         }
  //       });
  //   }
  // };

  render() {
    return (
      <LoginWrapper>
        <Router>
          <Switch>
            <Route exact path="/" component={Loading} />
            <PrivateRoute exact path="/bemvindo" component={Welcome} />
            <PrivateRoute
              exact
              path="/bemvindo/:id"
              component={WelcomeCategory}
            />
            <PrivateRoute exact path="/contrato" component={Contract} />
            <Layout>
              <PrivateRoute exact path="/recuperacao" component={Recovery} />
              <PrivateRoute exact path="/empresa/:cnpj" component={Company} />
              <PrivateRoute
                exact
                path="/empresa/:cnpj/resultado/:id"
                component={ViewResult}
              />
            </Layout>
          </Switch>
        </Router>
      </LoginWrapper>
    );
  }
}

export default App;
